
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/banned",
      function () {
        return require("private-next-pages/user/banned/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/banned"])
      });
    }
  